import React, { useState } from 'react';
import Nav from './components/Nav';
import Home from './screens/Home';
import LessonChat from './screens/LessonChat';
import Progress from './screens/Progress';
import Gate, { isVerified } from './screens/Gate';
import { useProgress } from './hooks/useProgress';
import { useChat } from './hooks/useChat';

// Main academy app — only rendered after verification
function Academy() {
  const [screen, setScreen] = useState('home');
  const [activeLesson, setActiveLesson] = useState(null);
  const [activeTrack, setActiveTrack] = useState(null);
  const { progress, completeLesson, addXp, getLevel } = useProgress();
  const level = getLevel();

  const lessonContext = activeLesson ? {
    title: activeLesson.title,
    description: activeLesson.description,
    challenge: activeLesson.challenge,
  } : null;

  const { messages, loading, sendMessage, startLesson, clearChat } = useChat(lessonContext);

  const handleStartLesson = (lesson, track) => {
    setActiveLesson(lesson);
    setActiveTrack(track);
    clearChat();
    startLesson(lesson);
    setScreen('lesson');
  };

  const handleOpenCoach = () => {
    setActiveLesson(null);
    setActiveTrack(null);
    clearChat();
    setScreen('coach');
  };

  const handleCompleteLesson = (lesson) => {
    completeLesson(lesson.id, lesson.xp);
    setScreen('home');
    setActiveLesson(null);
    setActiveTrack(null);
    clearChat();
  };

  const handleSend = (text) => {
    if (text === '__start_lesson__') {
      if (activeLesson) startLesson(activeLesson);
      return;
    }
    sendMessage(text);
    if (!activeLesson) addXp(5);
  };

  return (
    <div style={{ minHeight:'100vh', background:'#FBF7EE', color:'#1A1408', fontFamily:"'DM Sans','Segoe UI',sans-serif", fontSize:'18px', lineHeight:'1.7' }}>
      <Nav
        screen={screen}
        onNav={(s) => { setScreen(s); if (s !== 'lesson' && s !== 'coach') { clearChat(); setActiveLesson(null); } }}
        xp={progress.xp}
        streak={progress.streak}
        level={level}
      />

      {screen === 'home' && (
        <Home
          onStartLesson={handleStartLesson}
          onOpenCoach={handleOpenCoach}
          completedLessons={progress.completedLessons}
        />
      )}

      {(screen === 'lesson' || screen === 'coach') && (
        <LessonChat
          lesson={activeLesson}
          track={activeTrack}
          onBack={() => setScreen('home')}
          onComplete={handleCompleteLesson}
          messages={messages}
          loading={loading}
          onSend={handleSend}
        />
      )}

      {screen === 'progress' && (
        <Progress progress={progress} getLevel={getLevel} onBack={() => setScreen('home')} />
      )}
    </div>
  );
}

// Outer app — shows gate first then academy
export default function App() {
  const [verified, setVerified] = useState(isVerified());
  if (!verified) {
    return <Gate onVerified={() => setVerified(true)} />;
  }
  return <Academy />;
}
